import { PaginationQuery, SystemVersionListResponse } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

interface UseSystemVersionsParams extends PaginationQuery {
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
}

export function useSystemVersions({
  page = 1,
  pageSize = 10,
  sortBy = 'update_id',
  sortOrder = 'desc',
}: UseSystemVersionsParams = {}) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<SystemVersionListResponse>(
    token
      ? `/api/system-versions?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`
      : null,
    undefined,
    token ?? '',
  )

  return {
    systemVersions: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
